import React from 'react';

const ActivitiesFlood = () => {
  return (
    <section id="activities-flood">

      <h1>Bel- és csapadékvíz elvezetés</h1>

      <header>

        <div>
          <div id="activities-flood-info">

            <div>
              <h2>Üzletágvezető:</h2>
              <ul>
                <li>Ponyokai Bálint</li>
              </ul>
            </div>

            <div>
              <h2>Elérhetőség:</h2>
              <ul>
                <li><a href="tel: +36 70/610-1644">70/610-1644</a></li>
              </ul>
            </div>

          </div>

          <p>
            2013. január 15-től a Kft. végzi a város belterületi bel- és csapadékvíz elvezető rendszerének karbantartási munkáit. 
            <br/>
            Alapvető feladatunk, hogy a rendszer működőképességét biztosítsuk
          </p>

        </div>


        <div id="activities-flood-img"></div>

      </header>

      <div id="activities-flood-text">

        <p>
          <b>A tevékenység három feladatra bontható:</b>
        </p>

        <p>
          <b>1.</b>	Az újonnan épült csatorna és árokrendszer folyamatos ellenőrzése, karbantartása. A közterület-felügyelőkkel közösen elérni, hogy a lakosság, illetve a közület is a helyi rendeletekben meghatározott alapvető karbantartási feladatokat ellássa. 
        </p>

        <p>
          <b>2.</b> Az újonnan elkészült átemelő műtárgyak üzemképességének folyamatos és állandó biztosítása. A műtárgyakba beépített gépészeti berendezések előírás szerinti ellenőrzése, dokumentálása. 
          <br/>
          A karbantartási munkák elvégzésén túl kiemelten fontos az ellenőrzési, illetve felülvizsgálati dokumentumok vezetése, megőrzése. Az ellenőrzések során tapasztalt hiányosságokat írásban jelezzük a tulajdonos felé. Általános tájékoztatást igény szerint, az esetlegesen előforduló nagyobb rendellenességekről, mely sürgős beavatkozást igényel azonnali tájékoztatást adunk.

        </p>

        <p>
          <b>3.</b> A város területén található, régi rendszer állapotának megőrzése, javítása.
          <br/>
          A tervszerű karbantartás állapotmegőrzés érdekében folyamatosan keressük az önkormányzati képviselőket, hogy a körzetükben lévő problémákat jelezzék. A visszaküldött reagálásokat kivizsgáljuk, illetve a műszaki megoldást és annak anyagi vonzatát kidolgozzuk.
        </p>

        <p>
          Ezen tevékenységünk fontosságát kiemeli, hogy a polgárvédelmi és katasztrófavédelmi hatóságok kiemelten ellenőrzik. 
          <br/>
          A feladatok ellátásához rendelkezésünkre áll egy irányító és két fő fizikai munkás. 
          <br/>
          Az alapvető feladatokhoz szükséges gépparkkal rendelkezünk. 
          <br/>
          A feladat ellátása során törekszünk egy szorosabb kommunikációra, együttműködésre épülő kapcsolat kialakítására a képviselőkkel, illetve közterület felügyelőkkel.
          <br/>
          Célunk a tevékenység ellátásánál, a csapadékelvezető rendszer állapotának megőrizése, fejlesztése. 
        </p>

      </div>

    </section>
  );
};

export default ActivitiesFlood;